import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "../../components/ui/Dialog";
import { Alert, AlertDescription } from "../../components/ui/Alert";
import { Mic, Video, AlertCircle, CheckCircle2 } from "lucide-react";

interface PermissionDialogProps {
    open: boolean;
    permissions: {
        audio: boolean | null;
        video: boolean | null;
    };
    errors: {
        audioError: string | null;
        videoWarning: string | null;
    };
    onRequestPermissions: () => Promise<void>;
}

const PermissionDialog: React.FC<PermissionDialogProps> = ({
    open,
    permissions,
    errors,
    onRequestPermissions,
}) => {
    return (
        <Dialog open={open}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Media Permissions Required</DialogTitle>
                    <DialogDescription>
                        Please enable your microphone and camera to proceed with
                        the mock interview.
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4 py-4">
                    <div className="flex items-center space-x-4">
                        <div className="flex-1">
                            <div className="flex items-center space-x-2">
                                <Mic className="h-4 w-4" />
                                <span className="font-medium">Microphone</span>
                            </div>
                            {permissions.audio === true ? (
                                <Alert className="mt-2 border-green-500">
                                    <CheckCircle2 className="h-4 w-4 text-green-500" />
                                    <AlertDescription>
                                        Microphone access granted
                                    </AlertDescription>
                                </Alert>
                            ) : permissions.audio === false ? (
                                <Alert
                                    className="mt-2 border-red-500"
                                    variant="destructive">
                                    <AlertCircle className="h-4 w-4" />
                                    <AlertDescription>
                                        {errors.audioError || (
                                            <>
                                                Microphone access denied. Please{" "}
                                                <button
                                                    onClick={() =>
                                                        window.open(
                                                            "chrome://settings/content/microphone"
                                                        )
                                                    }
                                                    className="underline hover:no-underline">
                                                    enable it in your browser
                                                    settings
                                                </button>
                                            </>
                                        )}
                                    </AlertDescription>
                                </Alert>
                            ) : (
                                <Alert className="mt-2">
                                    <AlertCircle className="h-4 w-4" />
                                    <AlertDescription>
                                        Click top left or the browser settings
                                        to enable microphone access
                                    </AlertDescription>
                                </Alert>
                            )}
                        </div>
                    </div>

                    <div className="flex items-center space-x-4">
                        <div className="flex-1">
                            <div className="flex items-center space-x-2">
                                <Video className="h-4 w-4" />
                                <span className="font-medium">
                                    Camera (Optional)
                                </span>
                            </div>
                            {permissions.video === true ? (
                                <Alert className="mt-2 border-green-500">
                                    <CheckCircle2 className="h-4 w-4 text-green-500" />
                                    <AlertDescription>
                                        Camera access granted
                                    </AlertDescription>
                                </Alert>
                            ) : (
                                <Alert className="mt-2 border-yellow-500">
                                    <AlertCircle className="h-4 w-4 text-yellow-500" />
                                    <AlertDescription>
                                        {errors.videoWarning ||
                                            "Camera access recommended but optional"}
                                    </AlertDescription>
                                </Alert>
                            )}
                        </div>
                    </div>
                </div>

                {/* <div className="flex justify-end space-x-2">
                    {!permissions.audio && (
                        <Button
                            onClick={onRequestPermissions}
                            variant="default">
                            Grant Permissions
                        </Button>
                    )}
                    {permissions.audio && !permissions.video && (
                        <Button
                            onClick={onRequestPermissions}
                            variant="outline">
                            Enable Camera
                        </Button>
                    )}
                    {permissions.audio && (
                        <Button
                            variant="default"
                            onClick={() => window.location.reload()}>
                            Continue
                        </Button>
                    )}
                </div> */}
            </DialogContent>
        </Dialog>
    );
};

export default PermissionDialog;
